const EVO_PRODUCT_TYPES = new Set([
  "EVO-XXXX",
  "EVO-1212",
  "EVO-1224",
  "EVO-2212",
  "EVO-2224",
  "EVO-3012",
  "EVO-4024",
  "EVO-2212E",
  "EVO-2224E",
  "EVO-3012E",
  "EVO-4024E",
]);

const finiteNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const isSubThresholdOutputWatt = (value) => {
  const number = finiteNumber(value);
  return number !== null && Math.abs(number) < 12;
};

const signed16 = (value) => {
  const number = finiteNumber(value);
  if (number === null) return null;
  return Number.isInteger(number) && number >= 0x8000 && number <= 0xffff
    ? number - 0x10000
    : number;
};

const subtract = (input, invCharge) => {
  const inputNumber = finiteNumber(input);
  const invChargeNumber = finiteNumber(invCharge);
  if (inputNumber === null || invChargeNumber === null) return null;
  return Number((inputNumber - invChargeNumber).toFixed(6));
};

const add = (input, signedOffset) => {
  const inputNumber = finiteNumber(input);
  const offsetNumber = finiteNumber(signedOffset);
  if (inputNumber === null || offsetNumber === null) return null;
  return Number((inputNumber + offsetNumber).toFixed(6));
};

export const suppressDisconnectedInputFrequencies = (row) => {
  if (!row) return row;

  const gridVoltage = finiteNumber(row.grid_volt);
  const generatorPower = finiteNumber(row.input_watt);
  let adjustedRow = row;

  if (gridVoltage !== null && gridVoltage < 10 && row.grid_freq != null) {
    adjustedRow = {
      ...adjustedRow,
      raw_grid_freq: row.grid_freq,
      grid_freq: null,
    };
  }

  if (generatorPower !== null && generatorPower < 12 && row.gen_freq != null) {
    adjustedRow = {
      ...adjustedRow,
      raw_gen_freq: row.gen_freq,
      gen_freq: null,
    };
  }

  return adjustedRow;
};

// The legacy getfiledata API returns raw Inv/Charge registers. Newer logs APIs
// perform this conversion server-side before the dashboard receives the row.
export const adjustLegacyEvoOutputMetrics = (row) => {
  const adjustedRow = suppressDisconnectedInputFrequencies(row);
  const productType = adjustedRow?.product_type ?? adjustedRow?.product;
  if (!adjustedRow || Number(adjustedRow.mode) !== 2 || !EVO_PRODUCT_TYPES.has(productType)) {
    return adjustedRow;
  }

  const outputCurrent = subtract(adjustedRow.input_current, adjustedRow.output_current);
  const outputVa = subtract(adjustedRow.input_va, adjustedRow.output_va);
  const outputWatt = add(adjustedRow.input_watt, signed16(adjustedRow.output_watt));

  return {
    ...adjustedRow,
    ...(outputCurrent === null ? {} : { output_current: outputCurrent }),
    ...(outputVa === null ? {} : { output_va: outputVa }),
    ...(outputWatt === null ? {} : { output_watt: outputWatt }),
  };
};

export const adjustLegacyEvoOutputMetricsForRows = (rows) =>
  Array.isArray(rows) ? rows.map(adjustLegacyEvoOutputMetrics) : rows;
